import Badge from "ds/components/Badge";
import Box from "ds/components/Box";
import TableCellLink from "ds/components/Table/Row/CellLink";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { VcsIntegration } from "types/generated";
import VCSProviderIcon from "views/Account/Integrations/registry/shared/VcsShared/components/ProviderIcon";

const VCSIntegrationsTableNameCell = ({
  item: integration,
  ...cellProps
}: TableSimpleCellProps<VcsIntegration>) => {
  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <Box gap="medium" align="center">
        <VCSProviderIcon provider={integration.provider} />

        <TableCellLink href={`./${integration.id}`}>{integration.name}</TableCellLink>

        {integration.isDefault && <Badge variant="gray" type="strong" text="DEFAULT" />}
      </Box>
    </TableSimpleCell>
  );
};

export default VCSIntegrationsTableNameCell;
